import styled from 'styled-components';

import { device } from 'styles/breakpoints';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  button.button-contained {
    &:disabled {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    img.tick-icon {
      filter: brightness(0) invert(1);
      margin-left: 8px;
    }
  }

  @media ${device.tablet} {
    flex-direction: column;
  }
`;

const DotsWrapper = styled.div`
  position: absolute;
  top: 25px;
  left: 0;
  width: 216px;
  height: 115px;

  @media ${device.tablet} {
    display: none;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;

  h1 {
    max-width: 660px;
  }

  p {
    max-width: 560px;
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  }

  @media ${device.tablet} {
    gap: 25px;

    p {
      font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
    }
  }
`;

const EmailInput = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  position: relative;
  max-width: 354px;

  input {
    padding-right: 75px;
  }

  @media ${device.mobile} {
    max-width: 100%;
  }
`;

const Input = styled.input`
  height: 55px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grayPallet20};
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px 20px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.grayPallet26 : theme.colors.blackPallet6};
  font-size: 17px;
  line-height: 24px;
  transition: 200ms all ease;

  &.invalid {
    border: 1px solid ${({ theme }) => theme.colors.red};
  }
`;

const InputCTAWrapper = styled.div`
  position: absolute;
  right: 21px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 21px;

  button {
    width: 25px;
  }
`;

const InputDivider = styled.div`
  height: 25px;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.grayPallet19};
`;

const ErrorMessage = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.red};
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 594px;
  height: 412px;

  @media ${device.smallLaptop} {
    width: 450px;
    height: 312px;
  }

  @media ${device.tablet} {
    width: 100%;
    height: 350px;
    margin-top: 25px;
  }

  @media ${device.mobile} {
    width: 100%;
    height: 222px;
  }
`;

export default {
  Wrapper,
  DotsWrapper,
  ContentWrapper,
  EmailInput,
  InputWrapper,
  Input,
  InputCTAWrapper,
  InputDivider,
  ErrorMessage,
  ImageWrapper,
};
